import clsx from 'clsx'
import './Skeleton.css'

interface SkeletonProps {
    className?: string
}

export default function Skeleton({ className }: SkeletonProps) {
    return <span className={clsx('ui-skeleton', className)} aria-hidden="true" />
}
